// TOBE removed once  webpack Module Federation is stable
import React, { useEffect, useState, Suspense } from 'react';
import { loadRemoteComponent } from './remoteLoader';
import Loading from '../Loading';

export function RemoteComponentLoader({ url, scope, module, ...props }) {
  const [Component, setComponent] = useState(null);

  useEffect(() => {
    let canceled = false;

    loadRemoteComponent({ url, scope, module }).then((mod) => {
      if (!canceled) {
        setComponent(() => mod.default || mod);
      }
    });

    return () => {
      canceled = true;
    };
  }, [url, scope, module]);

  if (!Component) {
    return <Loading />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <Component {...props}/>
    </Suspense>
  );
}
